/* * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights
Reserved. * * Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with * the License. A copy of the
License is located at * * http://aws.amazon.com/apache2.0/ * * or in the
"license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR * CONDITIONS OF ANY KIND, either express or
implied. See the License for the specific language governing permissions * and
limitations under the License. */
<template>
  <div class="require-new-password-container">
    <!-- <div  >{{options.header}}</div> -->
    <div class="logo"><img src="@/assets/logo.png" /></div>
    <div class="title">新しいパスワードを入力してください</div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div>
        <div class="form-input">
          <!-- <div class="label">新しいパスワード</div> -->
          <ValidationProvider
            rules="required|complexPassword"
            v-slot="ProviderProps"
          >
            <input v-model="password" type="password" autofocus />
            <div
              class="input-note"
              :class="{ 'validation-error': ProviderProps.invalid }"
            >
              アルファベット大文字、小文字、数字をそれぞれ1文字以上含む、8文字以上で入力してください
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div
        v-for="attribute in options.user.challengeParam.requiredAttributes"
        :attribute="attribute"
        v-bind:key="attribute"
      >
        <!-- NOTE: 追加の必須情報は今のとこなし -->
        <div>{{ attribute.charAt(0).toUpperCase() + attribute.slice(1) }}</div>
        <input
          v-model="requiredAttributes[attribute]"
          :placeholder="attribute.charAt(0).toUpperCase() + attribute.slice(1)"
        />
      </div>
      <div class="actions">
        <div class="submit">
          <div
            class="button"
            :class="{ disable: ObserverProps.invalid }"
            v-on:click="change"
            :disabled="!password"
          >
            送信
          </div>
        </div>
        <div class="nav">
          <a v-on:click="signIn">戻る</a>
        </div>
      </div>
    </validation-observer>
    <div class="error" v-if="error">
      {{ error }}
    </div>
  </div>
</template>
<script>
// import AmplifyEventBus from '../../events/AmplifyEventBus';
import { AmplifyEventBus } from "aws-amplify-vue";
// import * as AmplifyUI from '@aws-amplify/ui';
// import { auth } from '../../assets/data-test-attributes';

export default {
  name: "RequireNewPassword",
  props: ["requireNewPasswordConfig"],
  data() {
    return {
      user: "",
      error: "",
      password: "",
      logger: {},
      requiredAttributes: {}
      // amplifyUI: AmplifyUI,
      // auth
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get("Enter new password"),
        user: {
          challengeParam: {
            requiredAttributes: []
          }
        }
      };
      return Object.assign(defaults, this.requireNewPasswordConfig || {});
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    },
    checkContact(user) {
      this.$Amplify.Auth.verifiedContact(user)
        .then(() => {
          AmplifyEventBus.$emit("localUser", this.user);
          AmplifyEventBus.$emit("authState", "signedIn");
          this.$router.replace("/");
        })
        .catch(e => this.setError(e));
    },
    change() {
      this.$Amplify.Auth.completeNewPassword(
        this.options.user,
        this.password,
        this.requiredAttributes
      )
        .then(() => {
          if (this.options.user.challengeName === "SMS_MFA") {
            AmplifyEventBus.$emit("localUser", this.options.user);
            AmplifyEventBus.$emit("authState", "confirmSignIn");
          } else if (this.options.user.challengeName === "MFA_SETUP") {
            AmplifyEventBus.$emit("localUser", this.options.user);
            AmplifyEventBus.$emit("authState", "setMfa");
          } else {
            this.checkContact(this.options.user);
          }
        })
        .catch(err => this.setError(err));
    },
    signIn: function() {
      AmplifyEventBus.$emit("authState", "signIn");
    }
  }
};
</script>

<style lang="scss">
.require-new-password-container {
  width: 100vw;
  background: #ffffff;
  padding: 3rem;
  color: var(--purple);

  .desktop & {
    width: 552px;
    box-shadow: 0px 0px 20px #00000029;
    border-radius: 25px;
  }

  .logo {
    height: 3rem;
    margin-bottom: 2rem;
    display: flex;
    justify-content: center;

    img {
      object-fit: contain;
    }
  }

  .title {
    margin-bottom: 1rem;
    font-weight: 600;
    text-align: center;
  }

  .form-input {
    margin-bottom: 1rem;

    .label {
      margin-bottom: 0.5rem;
    }

    input[type="text"],
    input[type="password"],
    input[type="date"] {
      width: 100%;
      height: 40px;
      border-radius: 20px;
      border: solid 1px var(--purple);
      padding: 0 16px;
      font-size: 16px;
      outline: none;
    }

    input[type="text"]:focus,
    input[type="password"]:focus,
    input[type="date"]:focus {
      background: var(--purple-tertiary);
    }

    .input-note {
      padding: 0.5rem 0 0 1rem;
      font-size: 80%;
    }
  }

  .actions {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    .desktop & {
      margin-top: 4rem;
      justify-content: space-between;
      flex-direction: row-reverse;
    }

    &.disable {
      cursor: none;
      pointer-events: none;
      opacity: 0.5;
    }

    .nav {
      display: flex;
      justify-content: start;
      align-items: center;
      color: #1a82b7;
      cursor: pointer;

      .mobile & {
        margin-top: 3rem;
      }

      a:active {
        opacity: 0.5;
      }
    }

    .submit {
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--purple);
        min-width: 140px;
        height: 44px;
        border-radius: 22px;
        color: #fff;
        padding: 0 1rem;
        cursor: pointer;

        &:active {
          opacity: 0.7;
        }
        &.disable {
          cursor: none;
          pointer-events: none;
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
